import React, { Component } from 'react';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { withLocaleContext } from '../../../../locales/locale-context.js';
import { actions } from '../../../../shared/store.js';
import { prefixPathWithLocale } from '../../../../locales/locale-paths.js';
import NewsService from '../news.service.js';
import PageNotFound from '../../../../components/not-found/page-not-found.js';
import NotImplemented from '../../../../components/not-implemented/not-implemented.js';

import noImage from '../../../../assets/images/news/details/no-photo-details.png';
import continueReading from '../../../../assets/images/news/details/continue-reading.jpg';

import './news-detail.scss';

class NewsDetailPage extends Component {
	static prefetchData = async (language, slug) => NewsService.getNewsDetailsBySlug(language, slug);

	state = {
		hasError: false,
		relatedNews: null,
	};

	componentDidMount() {
		const { newsDetail, match, setLoading } = this.props;

		if (!newsDetail || newsDetail.slug !== match.params.slug) {
			this.fetchData();
		} else {
			this.fetchRelatedNews(newsDetail);
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			match,
			localeContext: { locale },
		} = this.props;

		if (
			prevProps.localeContext.locale.value !== locale.value
			|| match.params.slug !== prevProps.match.params.slug
		) {
			this.fetchData();
		}
	}

	fetchData() {
		const {
			match,
			setLoading,
			setNewsDetail,
			localeContext: { locale },
		} = this.props;

		setLoading(true);
		NewsDetailPage.prefetchData(locale.value, match.params.slug)
			.then((data) => {
				setNewsDetail(data);
				this.fetchRelatedNews(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				this.setState({
					hasError: true,
				});
			});
	}

	fetchRelatedNews(newsDetail) {
		const {
			localeContext: { locale },
		} = this.props;

		NewsService.getNextRelatedNews(locale.value, newsDetail.date).then(
			(relatedNews) => {
				this.setState({ relatedNews });
			},
		);
	}

	render() {
		const { hasError, relatedNews } = this.state;
		const {
			isLoading,
			newsDetail,
			localeContext: { locale },
		} = this.props;

		if (isLoading) return null;

		if (!newsDetail) {
			return <PageNotFound />;
		}
		if (hasError) {
			return <NotImplemented />;
		}

		const {
			title, date, description, article, image,
		} = newsDetail;

		return (
			<div className="news-detail-page">
				<section className="header middle-xs">
					{image.path ? (
						<img
							className="logo"
							src={process.env.REACT_APP_API_ENDPOINT + image.path}
							alt={title}
						/>
					) : (
						<img className="logo" src={noImage} alt={title} />
					)}
					<div className="info">
						<div className="container container-fluid">
							<div className="row">
								<div className="col-xs-12">
									<div className="back-label">
										<Link to={prefixPathWithLocale('/news', locale)}>
											<FormattedMessage id="news.details.news_center" />
										</Link>
									</div>
								</div>
								<div className="col-xs-12 col-md-7">
									<div className="title">
										<h2>{title}</h2>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className="detail">
					<div className="container container-fluid">
						<div className="row center-xs ">
							<div className="col-xs-12 col-sm-10 col-md-7">
								<div className="container">
									<div className="row">
										<div className="col-xs-12 date">
											<FormattedDate
												value={date}
												month="short"
												day="numeric"
												year="numeric"
											/>
										</div>
										<div className="col-xs-12 description">
											<h6>{description}</h6>
										</div>
										<div className="col-xs-12">
											<div
												className="article"
												dangerouslySetInnerHTML={{ __html: article }}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				{relatedNews && (
					<Link to={prefixPathWithLocale(`/news/${relatedNews.slug}`, locale)}>
						<section className="continue-reading">
							{relatedNews.image.path ? (
								<img
									src={`${process.env.REACT_APP_API_ENDPOINT
										+ relatedNews.image.path}`}
									alt={relatedNews.title}
								/>
							) : (
								<img src={continueReading} alt={relatedNews.title} />
							)}
							<div className="container container-fluid content center-xs">
								<div className="row center-xs">
									<div className="col-xs-12 center-xs label">
										<small>
											<FormattedMessage id="news.details.continue_reading" />
										</small>
									</div>
									<div className="col-xs-12 col-sm-10 col-md-7 center-xs title">
										<h5>{relatedNews.title}</h5>
									</div>
								</div>
							</div>
						</section>
					</Link>
				)}
			</div>
		);
	}
}

const mapToProps = ({ newsDetail }) => ({
	newsDetail,
});

export default withLocaleContext(
	connect(
		mapToProps,
		actions,
	)(injectIntl(NewsDetailPage)),
);

export { NewsDetailPage };
